// Match only the new facade family, including a configured deployment prefix.
export const isTabletPairingUrl = (url) => {
  try {
    const path = new URL(url?.url || String(url), window.location.origin).pathname;
    return /\/v1\/restaurants\/[^/]+\/tablet-pairing(?:\/|$)/.test(path);
  } catch (_) {
    return false;
  }
};

let activeViews = 0;
export const enterTabletPairingView = () => {
  activeViews += 1;
  return () => { activeViews = Math.max(0, activeViews - 1); };
};

// Network breadcrumbs can be generated by Bugsnag independently of Api.js.
export const filterTabletPairingBreadcrumb = (breadcrumb) => {
  if (isTabletPairingUrl(breadcrumb?.metadata?.request) ||
      isTabletPairingUrl(breadcrumb?.metadata?.url)) return false;
  // Form values (including the transient code) must never become UI breadcrumbs.
  if (activeViews > 0 && breadcrumb?.type === 'user') return false;
  return undefined;
};
